/*
 * Generic Auth using Refresh Tokens
 */
import {
    getAccessTokenFromStore
} from "./token_actions";

// CFAuth actions using refresh tokens
export const CFAuthGetRef = ({
    url,
    params,
    customHeaders,
    originUrl,
    loaderName,
    customQueryParams
}) => {
    if (loaderName !== undefined && loaderName !== "")
        enqueueLoader(loaderName);
    let token = getAccessTokenFromStore();
    let paramString = "";

    let headers = {
        "Access-Control-Allow-Origin": originUrl,
        Authorization: "Bearer " + token
    };

    if (params && Object.keys(params).length > 0)
        paramString = Object.keys(params)
            .map(paramKey => {
                return `${paramKey}=${params[paramKey]}`;
            })
            .join("&");

    if (customQueryParams) paramString += customQueryParams;

    if (customHeaders && Object.keys(customHeaders).length > 0) {
        Object.keys(customHeaders).forEach(headerTitle => {
            headers[headerTitle] = customHeaders[headerTitle];
        });
    }

    return fetch(url + (paramString !== "" ? `?${paramString}` : ""), {
        credentials: "include",
        headers: headers
    }).then(response => {
        if (loaderName !== undefined && loaderName !== "")
            dequeueLoader(loaderName);
        return response.ok ? response.json() : response;
    });
};

export const CFAuthGetMediaRef = async ({
    url,
    params,
    customHeaders,
    originUrl,
    loaderName,
    customQueryParams,
    additionalParams
}) => {
    if (loaderName !== undefined && loaderName !== "")
        enqueueLoader(loaderName);
    let token = getAccessTokenFromStore();
    let paramString = "";

    let headers = {
        "Access-Control-Allow-Origin": originUrl,
        Authorization: "Bearer " + token
    };

    if (params && Object.keys(params).length > 0)
        paramString = Object.keys(params)
            .map(paramKey => {
                return `${paramKey}=${params[paramKey]}`;
            })
            .join("&");

    if (customQueryParams) paramString += customQueryParams;

    if (customHeaders && Object.keys(customHeaders).length > 0) {
        Object.keys(customHeaders).forEach(headerTitle => {
            headers[headerTitle] = customHeaders[headerTitle];
        });
    }
    
    return fetch(url + (paramString !== "" ? `?${paramString}` : ""), {
        credentials: "include",
        headers: headers,
        responseType: 'blob'
    })
    .then(response => response.blob())
    .then(images => {
        const allowedFileTypes = ["image/png", "image/jpeg", "image/gif"];
        let objectURL = false;

        if(allowedFileTypes.indexOf(images.type) > -1) {
            objectURL = URL.createObjectURL(images);
            if (loaderName !== undefined && loaderName !== "") dequeueLoader(loaderName);
        }

        return objectURL;
    })
};

export const CFAuthPostRef = ({
    url,
    body,
    customHeaders,
    originUrl,
    loaderName
}) => {
    if (loaderName !== undefined && loaderName !== "")
        enqueueLoader(loaderName);
    let token = getAccessTokenFromStore();

    let headers = {
        "Access-Control-Allow-Origin": originUrl,
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
    };

    if (customHeaders && Object.keys(customHeaders).length > 0) {
        Object.keys(customHeaders).forEach(headerTitle => {
            headers[headerTitle] = customHeaders[headerTitle];
        });
    }

    return fetch(url, {
        credentials: "include",
        headers: headers,
        method: "POST",
        body: JSON.stringify(body)
    }).then(response => {
        if (loaderName !== undefined && loaderName !== "")
            dequeueLoader(loaderName); 

        try {
            return response.text().then(t => {
                return t ? JSON.parse(t) : {};
            }).then((data) => {
                return {
                    ok: response.ok,
                    status: response.status,
                    message: response.ok ? null : data, // String
                    data: response.ok ? data : null // Object
                }
            });
        } catch (error) { 
            return {
                ok: response.ok,
                status: response.status,
                message: error,
                data: null           
            }
        } 
    }).catch(error => {
        return {
            ok: false,
            status: 500,
            message: error.message,
            data: null           
        }
    });
};

export const CFAuthPutRef = ({
    url,
    body,
    customHeaders,
    originUrl,
    loaderName
}) => {
    if (loaderName !== undefined && loaderName !== "")
        enqueueLoader(loaderName);
    let token = getAccessTokenFromStore();

    let headers = {
        "Access-Control-Allow-Origin": originUrl,
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
    };

    if (customHeaders && Object.keys(customHeaders).length > 0) {
        Object.keys(customHeaders).forEach(headerTitle => {
            headers[headerTitle] = customHeaders[headerTitle];
        });
    }

    return fetch(url, {
        credentials: "include",
        headers: headers,
        method: "PUT",
        body: JSON.stringify(body)
    }).then(response => {
        if (loaderName !== undefined && loaderName !== "")
            dequeueLoader(loaderName); 

        try {
            return response.text().then(t => {
                return t ? JSON.parse(t) : {};
            }).then((data) => {
                return {
                    ok: response.ok,
                    status: response.status,
                    message: response.ok ? null : data, // String
                    data: response.ok ? data : null // Object
                }
            });
        } catch (error) { 
            return {
                ok: response.ok,
                status: response.status,
                message: error,
                data: null           
            }
        } 
    }).catch(error => {
        return {
            ok: false,
            status: 500,
            message: error.message,
            data: null           
        }
    });
};


export const CFAuthPatchRef = ({
    url,
    body,
    customHeaders,
    originUrl,
    loaderName
}) => {
    if (loaderName !== undefined && loaderName !== "")
        enqueueLoader(loaderName);
    let token = getAccessTokenFromStore();

    let headers = {
        "Access-Control-Allow-Origin": originUrl,
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
    };

    if (customHeaders && Object.keys(customHeaders).length > 0) {
        Object.keys(customHeaders).forEach(headerTitle => {
            headers[headerTitle] = customHeaders[headerTitle];
        });
    }

    return fetch(url, {
        credentials: "include",
        headers: headers,
        method: "PATCH",
        body: JSON.stringify(body)
    }).then(response => {
        if (loaderName !== undefined && loaderName !== "")
            dequeueLoader(loaderName); 

        try {
            return response.text().then(t => {
                return t ? JSON.parse(t) : {};
            }).then((data) => {
                return {
                    ok: response.ok,
                    status: response.status,
                    message: response.ok ? null : data, // String
                    data: response.ok ? data : null // Object
                }
            });
        } catch (error) { 
            return {
                ok: response.ok,
                status: response.status,
                message: error,
                data: null           
            }
        } 
    }).catch(error => {
        return {
            ok: false,
            status: 500,
            message: error.message,
            data: null           
        }
    });
};


// WEBPACK FOOTER //
// ./src/auth/auth_actions_generic.js